class UndoBuffer {
    constructor() {
        this._buf = [];
        this._nextPosition = 0;
    }

    canUndo() {
        return this._nextPosition > 0;
    }
    canRedo() {
        return this._nextPosition < this._buf.length;
    }
    push(command) {
        this._buf[this._nextPosition++] = command;
        if (this._buf.length > this._nextPosition) {
            this._buf.splice(this._nextPosition);
        }
    }
    undo(receiver) {
        if (!this.canUndo()) return;
        let command = this._buf[--this._nextPosition];
        receiver.deepUpdate(command.path, command.reverse);
    }
    redo(receiver) {
        if (!this.canRedo()) return;
        let command = this._buf[this._nextPosition++];
        receiver.deepUpdate(command.path, command.forward);
    }
}

export { UndoBuffer };
